
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import * as XLSX from 'xlsx';

import Excel from '@grapecity/spread-excelio';

import { BaseApp } from '../BaseApp';
import { Bulletin } from '../models/Bulletin';
import { Cours } from '../models/Cours';
import { Period } from '../models/Period';
import { Results } from '../models/Results';
import { User } from '../models/User';
import { XCours } from '../models/XCours';
import { XUser } from '../models/XUser';
import { Categorie } from '../models/Categorie';
import { XCategorie } from '../models/XCategorie';
import { ItemType } from './ItemType';
import { XCategorieCours } from '../models/XCategorieCours';

@Component({
  selector: 'app-tools-right',
  templateUrl: './tools-right.component.html',
  styleUrls: ['./tools-right.component.css']
})
export class ToolsRightComponent extends BaseApp implements OnInit {

  @Input() period: Period;
  @Output('saveItem') saveItem: EventEmitter<any> = new EventEmitter<any>();
  categorie: any = {
     code: '',
     name: '',
     note_total: 10,
     note_pass: 6,
     note_rep: 5,
     note_exc: 8 ,
     is_calc: true,
     is_number:true,
     total_cours: 0,
    };
  cours = {
     code: '',
     name: '',
     note_total: 10,
     note_pass: 6,
     note_rep: 5,
     note_exc: 8 ,
     is_calc: true,
     is_number:true,
     cat_code: ''
    };
  user = { code: '', name: '', section: '', sexe:false};
  ut = false;
  ct = false;
  euser: any;
  eupos;
  ecpos;
  ecours: any;
  excelIO;
  rcours;
  rstudent;
  importResultsUser: XUser[] = [];
  importResultsCours: XCours[] = [];
  importResultsCats:XCategorie[] = [];
  importResultsCatsCours:XCategorieCours [] = [];
  locker = true ;
  isMerge: boolean = false;
  sc;
  scat: any;
 constructor() {
    super();
    this.excelIO = new Excel.IO();

  }

  clearFile(){
    this.importResultsUser  = [];
    this.importResultsCours = [];
    this.importResultsCats  = [];
    this.importResultsCatsCours = [];
  }

  ngOnInit(): void {
    console.log(this.period);
    this.hcours = this.period.cours;
  }

  closeEditUser() {
     this.euser = undefined;
     this.eupos = -1;
     this.ut = false;
  }
  closeEditCours() {
    this.ecours = undefined;
    this.ecpos = -1;
    this.ct = false;
  }

  editUser(o, i) {
    this.euser = o;
    this.eupos = i;
    this.ut = true;
  }


  delUser(o: User, j) {
      this.delHUsers(o.code);
      this.period.users.splice(j, 1);
      for (let i = 0; i < this.period.bulletins.length; i++) {
        if (o.code === this.period.bulletins[i].user.code) {
          this.period.bulletins.splice(i, 1);
          break;
        }
      }
      this.setAlert('alert-info alert-login', 'Succès', 104);

  }

 cat = false;
 ecat: any;
 ecatpos = -1;

 editCategorie(o, i) {
    this.ecat = o;
    this.ecatpos = i;
    this.cat = true;
  }

  editCours(o, i) {
    this.ecours = o;
    this.ecpos = i;
    this.ct = true;
  }

  delCours(o: Cours, j) {
     // if (this.period.cours.length > 1) {
      this.delHCours(o.code);
      this.period.cours.splice(j, 1);
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.period.bulletins.length; i++) {
        // tslint:disable-next-line:prefer-for-of
        for (let k = 0; k < this.period.bulletins[i].results.length; k++) {
          if (o.code === this.period.bulletins[i].results[k].cours.code) {
            this.period.bulletins[i].results.splice(k, 1);
            break;
          }
        }
      }
      this.setAlert('alert-info alert-login', 'Succès', 204);
}

 delCategorie(o: Categorie, j) {
     // if (this.period.cours.length > 1) {
      this.delHCategie(o.code);
      this.period.categories.splice(j, 1);
      for (let i = 0; i < this.period.cours.length; i++) {
          if (this.period.cours[i].cat_code==o.code){
              this.delCours(this.period.cours[i], i);
          }
      }
      this.setAlert('alert-info alert-login', 'Succès', 210);
}

delHCategie(code){
      for (let i = 0; i < this.hcats.length; i++) {
          if(this.hcats[i].code==code){
              this.hcats.splice(i,1);
           }
       }
}

delHCours(code){
    for (let i = 0; i < this.hcours.length; i++) {
          if(this.hcours[i].code==code){
              this.hcours.splice(i,1);
           }
       }
  }


  addUserNow() {
    if (this.user.code !== '' && this.user.name !== '') {
      this.addUser(this.user);
    } else {
        this.setAlert('alert-danger alert-login', 'Tout les champs doivent être remplis', 100);
    }
  }

  addUser(user: any) {
    if (!this.search(user.code, this.period.users)) {
      let sexe = (user.sexe == true || user.sexe == 1) ? true : false;
      const u = new User(user.code, user.name, user.section, sexe);
      this.period.users.push(u);
      // tslint:disable-next-line:prefer-const
      let res: Results[] = [];
      this.period.cours.forEach(element => {
        const cr = this.period.annee + '-' + this.period.classe + '-' + this.period.name + '-' + element.code + '-' + u.code;
        const r = new Results(cr, element, '');
        res.push(r);
      });
      const b = new Bulletin(u, res, this.period.coef);
      this.period.bulletins.push(b);
      this.setAlert('alert-info alert-login', 'Succès', 100);
      this.user = { code: '', name: '', section: '', sexe:false};
    } else {
      this.setAlert('alert-danger alert-login', 'Le code existe deja', 100);
    }
  }
  onFileChangeUser(args) {
    const self = this;
    const file = args.srcElement && args.srcElement.files && args.srcElement.files[0];
    const f = file.name.split('.');
    const ext = f[f.length - 1];
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: any = e.target.result;
      const data = this.importFromFile(bstr) as any[];

      const header: string[] = Object.getOwnPropertyNames(new XUser());
      const importedData = data.slice(1, -1);
      this.importResultsUser = importedData.map((arr) => {
        const obj = {};
        for (let i = 0; i < header.length; i++) {
          const k = header[i];
          obj[k] = arr[i];
        }
        return obj as XUser;
      });
      console.log(this.importResultsUser);
    };
    reader.readAsArrayBuffer(file);
  }

  onFileChangeCours(args) {
    const self = this;
    const file = args.srcElement && args.srcElement.files && args.srcElement.files[0];
    const f = file.name.split('.');
    const ext = f[f.length - 1];
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: any = e.target.result;
      const data = this.importFromFile(bstr) as any[];

      const header: string[] = Object.getOwnPropertyNames(new XCours());
      const importedData = data.slice(1, -1);

      this.importResultsCours = importedData.map((arr) => {
        const obj = {};
        for (let i = 0; i < header.length; i++) {
          const k = header[i];
          obj[k] = arr[i];
        }
        return obj as XCours;
      });
    };
    reader.readAsArrayBuffer(file);
  }

  fileCats: any;

  onFileChangeCategorie(event) {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file) return;
    this.fileCats = file;
    const reader: FileReader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      const bstr = e.target?.result as ArrayBuffer;
      const data = this.importFromFile(bstr) as any[];
      let header: string[] = (!this.isMerge) ? Object.getOwnPropertyNames(new XCategorie()) : Object.getOwnPropertyNames(new XCategorieCours());

      const importedData = data.slice(1, -1);

      const datacc : XCategorieCours [] | XCategorie []  = importedData.map((arr) => {
        const obj = {};
        for (let i = 0; i < header.length; i++) {
          const k = header[i];
          obj[k] = arr[i];
        }
        return obj as any;
      });
      if(!this.isMerge)
         this.importResultsCats = datacc as XCategorie[];
      else
       this.importResultsCatsCours = datacc as XCategorieCours []
    };

    reader.readAsArrayBuffer(file);
  }

 public importFromFile(buffer: ArrayBuffer): XLSX.AOA2SheetOpts {
  const wb: XLSX.WorkBook = XLSX.read(buffer, { type: 'array' });
  const wsname: string = wb.SheetNames[0];
  const ws: XLSX.WorkSheet = wb.Sheets[wsname];
  const data = XLSX.utils.sheet_to_json(ws, { header: 1 }) as XLSX.AOA2SheetOpts;
  return data;
}

public async addUserByXSLX() {
if (!this.locker) {return; }
this.locker = false;
const sl = this.importResultsUser.length;
await this.showLoading(true, 1);
if (sl !== 0) {
       const timer = setTimeout(function() {
         clearTimeout(timer);
           this.addUserFinish(sl);
        }.bind(this), 2000);
     } else {
          this.locker = true;
          this.closeLoading();
          this.setAlert('alert-danger alert-login', 'Vous devez sélectionner un fichier excell', 300);
    }
  }
  addUserFinish(sl) {
     for (let i = 0; i < sl; i++) {
          this.addUser(this.importResultsUser[i]);
      }
     this.locker = true;
     this.setAlert('alert-info alert-login', 'Succès', 300);
     this.closeLoading();
  }

  public addCategoriesByXSLX() {
   if (!this.isMerge)
     this.addCategorieSimple();
   else
     this.addCategorieMerge();
  }

  public addCategorieMerge(){
 try {
    if (this.importResultsCatsCours.length !== 0) {
     const checker = this.importResultsCatsCours[0];
     console.log(checker);
     if (checker && !checker.is_categorie) {
           console.log(checker);
           this.setWrongFormat();
           return ;
     }
   const cats = []
   const cours = []
   this.showLoading(true, 2);
      for (let i = 0 ; this.importResultsCatsCours.length;  i++) {
        const cat:XCategorieCours = this.importResultsCatsCours[i];
        if (!cat || cat.code === "*"  ) break;
        if (cat.is_categorie == 1) {
          const nc = this.addCategorie(cat as XCategorie);
                 if(nc && nc.code) cats.push(nc);
         }
         continue;
      }
     this.populate(ItemType.A_CATEGORY, cats);
      for (let i = 0 ; this.importResultsCatsCours.length;  i++) {
        const cat:XCategorieCours = this.importResultsCatsCours[i];
        if (!cat || cat.code === "*"  ) break;
        if (cat.is_categorie == 0)  {
          const c = this.addCours(cat as XCours);
                if(c && c.code) cours.push(c);
        }
        continue;
      }
      console.log(cats);
      this.populate(ItemType.A_COURS, cours);
      this.setAlert('alert-info alert-login', 'Succès', 301);
      this.closeLoading();
    } else {
      this.setAlert('alert-danger alert-login', 'vous devez sélectionner un fichier excell', 301);
      this.closeLoading();
    }
  } catch(e) {
      console.log(this.importResultsCatsCours);
      console.log(e);
      this.setWrongFormat();
      return ;
  }
   this.clearFile();
  }

  setWrongFormat() {
   this.setAlert('alert-danger alert-login', `Ce fichier n'est pas valide. Vous devez suivre ce format:
         \n
          is_categorie: Nombre 0=Non | 1=Oui;   \n
          code: Texte ;   \n
          name: Texte; \n
          note_total: c | Texte; \n
          note_pass: Nombre | Texte; \n
          note_rep:   Nombre | Texte; \n
          note_exc:   Nombre | Texte; \n
          is_calc: Nombre  0=Non | 1=Oui; \n
          is_number: Nombre 0=Non | 1=Oui; \n
          //
          cat_code: Texte | ;
          total_cours: Nombre ;
          \n
        `, 301);
      this.closeLoading();
  }

  public addCategorieSimple (){
   this.scat =  this.importResultsCats.length;
   const cats = []
   this.showLoading(true, 2);
   if (this.importResultsCats.length !== 0) {
       this.importResultsCats.forEach(cat => {
        --this.scat;
       const c = this.addCategorie(cat);
        if(c) cats.push(c);
        if (this.scat === 0) {
            this.populate(ItemType.A_CATEGORY, cats);
            this.setAlert('alert-info alert-login', 'Succès', 301);
            this.closeLoading();
         }
      });
    } else {
      this.setAlert('alert-danger alert-login', 'vous devez sélectionner un fichier excell', 301);
      this.closeLoading();
    }
  }

  public addCoursByXSLX() {
   this.sc = this.importResultsCours.length;
   this.showLoading(true, 2);
   const acours = [];
   if (this.importResultsCours.length !== 0) {
      this.importResultsCours.forEach(cours => {
        --this.sc;
        const c = this.addCours(cours);
        if (c) acours.push(c);
        if (this.sc === 0) {
            this.setAlert('alert-info alert-login', 'Succès', 301);
            this.closeLoading();
            this.populate(ItemType.A_COURS, acours);
         }
      });
    } else {
    this.setAlert('alert-danger alert-login', 'vous devez sélectionner un fichier excell', 301);
    this.closeLoading();
    }

  }

    populate(type: ItemType, data: any){
         this.saveItem.emit({  type, data });

    }

   addCategorie(c: XCategorie) {
      if (!c || c.code == "*" || c.code == "**") {
          return ;
      }
      if (!this.search(c.code, this.period.categories)) {
        // tslint:disable-next-line:max-line-length
        // tslint:disable-next-line:variable-name
        const is_calc = (c.is_calc === 1) ? true : false;
        const is_number = (c.is_number === 1) ? true : false;
        // tslint:disable-next-line:max-line-length
        const cat = new Categorie(c.code, c.name, c.note_total, c.note_pass, c.note_rep, c.note_exc, is_calc, is_number, c.total_cours);
        return cat;
      }
      return undefined;
    }

    addCategorieNow() {
    if (this.categorie.code !== '' && this.categorie.name !== '' ) {
        if (!this.search(this.categorie.code, this.period.categories)) {
        // tslint:disable-next-line:max-line-length
         const c = new Categorie(
           this.categorie.code,
           this.categorie.name,
           this.categorie.note_total,
           this.categorie.note_pass,
           this.categorie.note_rep,
           this.categorie.note_exc,
           this.categorie.is_calc,
           this.categorie.is_number,
           this.categorie.note_total);
           c.is_number = this.categorie.is_number;
           this.populate(ItemType.CATEGORY, c);
           this.setAlert('alert-info alert-login', 'Succès', 200);
      } else {
      this.setAlert('alert-danger alert-login', 'Le code existe deja', 200);
     }

    } else {
    this.setAlert('alert-danger alert-login', 'Tout les champs doivent être rempli', 200);
    }

    }

    addCours(c: XCours) {
      if (!this.search(c.code, this.period.cours)) {
        // tslint:disable-next-line:max-line-length
        // tslint:disable-next-line:variable-name
        const is_calc = (c.is_calc === 1) ? true : false;
        const is_number = (c.is_number=== 1) ? true : false;
        // tslint:disable-next-line:max-line-length
        const cours = new Cours(c.code, c.name, c.note_total, c.note_pass, c.note_rep, c.note_exc, is_calc, is_number, c.cat_code);
        return cours;
      }
      return undefined;
    }
    addCoursNow() {
    if (this.cours.code !== '' && this.cours.name !== '' ) {
        if (!this.search(this.cours.code, this.period.cours)) {
        // tslint:disable-next-line:max-line-length
        const cours = new Cours(
           this.cours.code,
           this.cours.name,
           this.cours.note_total,
           this.cours.note_pass,
           this.cours.note_rep,
           this.cours.note_exc,
           this.cours.is_calc,
           this.cours.is_number,
           this.cours.cat_code);
           cours.is_number = this.cours.is_number;
           this.populate(ItemType.COURS, cours);
        this.setAlert('alert-info alert-login', 'Succès', 200);
      } else {
      this.setAlert('alert-danger alert-login', 'Le code existe deja', 200);
     }

    } else {
       this.setAlert('alert-danger alert-login', 'Tout les champs doivent être rempli', 200);
    }

    }
  editCoursNow(ecours: Cours) {
    let nc: Cours;
    // tslint:disable-next-line:prefer-for-of
    for (let m = 0; m < this.period.cours.length; m++) {
      if (ecours.code === this.period.cours[m].code) {
            this.period.cours[m].name       = ecours.name;
            this.period.cours[m].note_total = ecours.note_total;
            this.period.cours[m].note_pass  = ecours.note_pass;
            this.period.cours[m].note_rep   = ecours.note_rep;
            this.period.cours[m].note_exc   = ecours.note_exc;
            this.period.cours[m].is_calc    = ecours.is_calc;
            this.period.cours[m].is_number  = ecours.is_number;
            this.period.cours[m].cat_code  = ecours.cat_code;
            break;
      }
    }
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.period.bulletins.length; i++) {
      // tslint:disable-next-line:prefer-for-of
      for (let k = 0; k <   this.period.bulletins[i].results.length; k++) {
        if (ecours.code === this.period.bulletins[i].results[k].cours.code) {
            this.period.bulletins[i].results[k].cours = ecours;
            break;
        }
      }
    }
    this.setAlert('alert-info alert-login', 'Succès', 202);
  }

  editCategorieNow(obj: Categorie) {
    let nc: Categorie;
    // tslint:disable-next-line:prefer-for-of
    for (let m = 0; m < this.period.categories.length; m++) {
      if (obj.code === this.period.categories[m].code) {
            this.period.categories[m].name       = obj.name;
            this.period.categories[m].note_total = obj.note_total;
            this.period.categories[m].note_pass  = obj.note_pass;
            this.period.categories[m].note_rep   = obj.note_rep;
            this.period.categories[m].note_exc   = obj.note_exc;
            this.period.categories[m].is_calc    = obj.is_calc;
            this.period.categories[m].is_number  = obj.is_number;
            this.period.categories[m].total_cours = obj.total_cours;
            break;
      }
    }
    //
    this.setAlert('alert-info alert-login', 'Succès', 209);
  }

   editUserNow(euser: User) {
     console.log(euser);
    // tslint:disable-next-line:prefer-for-of
    for (let m = 0; m < this.period.users.length; m++) {
      if (euser.code == this.period.users[m].code) {
            this.period.users[m] = euser;
            break;
      }
    }
    // // tslint:disable-next-line:prefer-for-of
     for (let i = 0; i < this.period.bulletins.length; i++) {
    //   // tslint:disable-next-line:prefer-for-of
      if (euser.code == this.period.bulletins[i].user.code) {
            this.period.bulletins[i].user = euser;
            break;
       }
     }
     this.setAlert('alert-info alert-login', 'Succès', 302);
  }


  search(nameKey, myArray) {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < myArray.length; i++) {
        // tslint:disable-next-line:triple-equals
        if (myArray[i].code == nameKey) {
          return true;
        }
    }
    return false;
  }

  cleanUser() {
      this.period.bulletins = [];
      this.period.users = [];
      this.setAlert('alert-info alert-login', 'Succès', 210);
  }

   cleanCours() {
      this.period.bulletins = [];
      this.period.cours = [];
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.period.bulletins.length; i++) {
           this.period.bulletins[i].results = [];
       }
      this.setAlert('alert-info alert-login', 'Succès', 204);
   }

  cleanCategorie() {
      this.period.categories = [];
      this.period.cours = [];
      // tslint:disable-next-line:prefer-for-of
      this.cleanCours()
      this.setAlert('alert-info alert-login', 'Succès', 204);
   }

hcours = [];
hcats = [];

ckey = 0;
catKey = 0;
onCoursKey(e) {
     if(this.ckey==0){
      this.hcours = this.period.cours;
      this.ckey++;
     }
    const query = e.target.value;
    if (query != null && query !== "" && query !== undefined) {
      this.period.cours = this.filterCoursItems(query);
     } else {
      this.period.cours = this.hcours;
      this.hcours = [];
      this.ckey = 0;
    }
}

onCategorieKey(e) {
     if(this.catKey==0){
        this.hcats = this.period.categories;
        this.catKey++;
     }
    const query = e.target.value;
    if (query != null && query !== "" && query !== undefined) {
       this.period.categories = this.filterCategorieItems(query);
     } else {
      this.period.categories = this.hcats;
      this.hcats = [];
      this.catKey = 0;
    }
  }

  filterCategorieItems(searchTerm) {
    return this.period.categories.filter((item) => {
      return (
        item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
        item.code.toString().toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      );
    });
  }


filterCoursItems(searchTerm) {
    return this.period.cours.filter((item) => {
      return (
        item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
        item.code.toString().toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      );
    });
  }


  // ----------------------
hstuds = [];
skey = 0;
onUsersKey(e) {
     if(this.skey==0){
      this.hstuds = this.period.users;
      this.skey++;
     }
    const query = e.target.value;
    if (query != null && query !== "" && query !== undefined) {
      this.period.users = this.filterStudsItems(query);
     } else {
      this.period.users = this.hstuds;
      this.hstuds = [];
      this.skey = 0;
    }
  }


filterStudsItems(searchTerm) {
    return this.period.users.filter((item) => {
      return (
        item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
        item.code.toString().toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      );
    });
  }

  delHUsers(code){
    for (let i = 0; i < this.hstuds.length; i++) {
          if(this.hstuds[i].code==code){
              this.hstuds.splice(i,1);
           }
       }
  }

}
